import * as React from 'react';



export default class Video extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg viewBox="0 0 50 50" className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">
        <g id="video-play/yellow" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="audio_pause_icon-copy">
            <g id="Group-Copy" transform="translate(1.000000, 1.000000)">
                <circle id="Oval" stroke="#FFFFFF" fillOpacity="0.3" fill="#000000" cx="24" cy="24" r="24"></circle>
                <polygon id="Triangle" fill="#FFFFFF" opacity="0.800000012" transform="translate(27.000000, 23.392857) rotate(90.000000) translate(-27.000000, -23.392857) " points="27 15 37 32 17 32"></polygon>
                </g>
            </g>
        </g>
      </svg>
    )
  }
}
